import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_SourceType_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_SOURCETYPE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Source Type Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SOURCE_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SourceType Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    SOURCE_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SourceType Id', columnResourceName: 'colSId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    SYSTEM_TYPE:{
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source Sub-Type', columnResourceName: 'colSSubType', alignment: HorizAlignment.Left},
        domainOptions: {domainIds: ['SourceSubTypes'], useIdAsKey: true, maxLength: 150}
    }


};

const ModelSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_SOURCETYPE_ID',
        id_ui: 'SOURCE_TYPE_ID',
        name: 'SOURCE_TYPE_NAME'

    },

    searchProviderFields: vUI_SourceType_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_SourceType_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const SourceTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "SourceTypeSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SOURCE_TYPE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SOURCE_TYPE_NAME', renderOptions: {}},

    ], //ISearchFields
    profileDisplayFields: [
        'SOURCE_TYPE_ID', 'SOURCE_TYPE_NAME',"SYSTEM_TYPE",
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SourceTypeSearch: ISearch = {
    searchName: "Find Source Type",
    renderOptions: {ui5ResourceId: "SourceTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SourceTypeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SourceTypeBO", "SourceType", SourceTypeSearch, "SourceType Search")

export {SourceTypeSearch}